import React, { useState } from 'react'
import { Edit } from '@mui/icons-material';
import { editAppinfo } from '../../Controllers/AppManagement/helpSupport';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
export default function EditAppInfo({ title, id, name, greyImage, file, cb, allowIcon = true }) {
  const [state, setState] = useState({ open: false, file: null, greyImage: null, name: name })

  const handleEdit = async () => {
    const form = new FormData()
    form.append("id", id)
    form.append("name", state.name)

    form.append("file", state.file)
    form.append("greyImage", state.greyImage)

    if (state.file) {
      var idxDot = state.file.name.lastIndexOf(".") + 1
      var extFile = state.file.name.substr(idxDot, state.file.name.length).toLowerCase()
      if (extFile !== "png") {
        return alert("Only png files are allowed!")
      }
    }
    if (state.greyImage) {
      idxDot = state.greyImage.name.lastIndexOf(".") + 1
      extFile = state.greyImage.name.substr(idxDot, state.greyImage.name.length).toLowerCase()
      if (extFile !== "png") {
        return alert("Only png files are allowed!")
      }
    }

    const res = await editAppinfo(form)
    if (res.data.status === 200) {
      handleClose()
      cb(res.data.data.data)
    }
  }

  const handleClose = () => {
    setState({ ...state, open: false })
  }
  return (
    <React.Fragment>
      <div>
        <Edit className="pointer" sx={{ marginRight: 2 }} onClick={() => setState({ ...state, open: true })} />
      </div>
      <Dialog open={state.open} onClose={handleClose} sx={{ minWidth: "300px" }}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent sx={{ minWidth: "300px" }}>
          <React.Fragment>
            <img
              style={{ width: "70px", margin: "10px 0 10px 0" }}
              src={state.file ? URL.createObjectURL(state.file) : file}
              alt=""
            />
            <strong
              style={{
                display: "block",
              }}
            >
              Active Image
            </strong>
            <input
              accept="image/png"
              type="file"
              id="attachedFile"
              onChange={(e) => {
                setState({ ...state, file: e.target.files[0] })
              }}
            />

            <br />
            <img
              style={{ width: "70px", margin: "10px 0 10px 0" }}
              src={state.greyImage ? URL.createObjectURL(state.greyImage) : greyImage}
              alt=""
            />
            <strong
              style={{
                display: "block",
              }}
            >
              Inactive Image
            </strong>
            <input
              accept="image/png"
              type="file"
              id="greyImage"
              onChange={(e) => {
                setState({ ...state, greyImage: e.target.files[0] })
              }}
            />
          </React.Fragment>
          <TextField
            autoFocus
            margin="dense"
            id="content"
            label="Availability"
            type="text"
            fullWidth
            variant="standard"
            defaultValue={name}
            inputProps={{ maxLength: 50 }}
            onChange={(e) => {
              setState({ ...state, name: e.target.value })
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} size="small">
            Cancel
          </Button>
          <Button onClick={handleEdit} variant="contained" size="small">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  )
}
